import sitecfg from '@/sitecfg.js'

const app = {
  state: {
    local_user: {
      id: '',
      address: "",
      email: "",
      username: "",
      imageURL: "",
    },
    data_list_liked: [],
  },
  mutations: {
    setLocalUserKey(state, obj) {
      for (let key in obj) {
        state.local_user[key] = obj[key];
      }
    },
    setUserKey(state, obj) {
      for (let key in obj) {
        state[key] = obj[key];
      }
    },
  },
}

export default app